// src/store/selectors/themeSelectors.js
import { createSelector } from '@reduxjs/toolkit';

export const selectTheme = (state) => state.theme;

export const selectThemeMode = createSelector([selectTheme], (theme) => theme.mode);

export const selectIsDarkMode = createSelector([selectThemeMode], (mode) => mode === 'dark');

export const selectIsLightMode = createSelector([selectThemeMode], (mode) => mode === 'light');

export const selectPrimaryColor = createSelector([selectTheme], (theme) => theme.primaryColor);

export const selectBorderRadius = createSelector([selectTheme], (theme) => theme.borderRadius);

export const selectFontFamily = createSelector([selectTheme], (theme) => theme.fontFamily);

export const selectDirection = createSelector([selectTheme], (theme) => theme.direction);

export const selectIsRTL = createSelector([selectDirection], (direction) => direction === 'rtl');

export const selectIsLTR = createSelector([selectDirection], (direction) => direction === 'ltr');

export const selectCompactMode = createSelector([selectTheme], (theme) => theme.compactMode);

export const selectSidebarBg = createSelector([selectTheme], (theme) => theme.sidebarBg);

export const selectHeaderBg = createSelector([selectTheme], (theme) => theme.headerBg);

export const selectContentBg = createSelector([selectTheme], (theme) => theme.contentBg);

export const selectThemeConfig = createSelector([selectTheme], (theme) => ({
    mode: theme.mode,
    primaryColor: theme.primaryColor,
    borderRadius: theme.borderRadius,
    fontFamily: theme.fontFamily,
    direction: theme.direction,
    compactMode: theme.compactMode,
    sidebarBg: theme.sidebarBg,
    headerBg: theme.headerBg,
    contentBg: theme.contentBg
}));
